import { RuleType } from '../components/VersionCard/pageData';

/** 基础版计费项 */
export const BASIC_CHARGE_ITEMS = [
  {
    key: 'sv_tencentmeeting_saas_eventb_year',
    pageKey: 'year',
    name: '基础版版本功能',
  },
  {
    key: 'sv_tencentmeeting_saas_eventb_guest',
    pageKey: 'guestNum',
    name: '嘉宾数',
  },
  {
    key: 'sv_tencentmeeting_saas_eventb_host',
    pageKey: 'hostNum',
    name: '主持人数',
  },
  {
    key: 'sv_tencentmeeting_saas_eventb_admin',
    pageKey: 'adminNum',
    name: '主办方成员数',
  },
  {
    key: 'sv_tencentmeeting_saas_eventb_st100',
    pageKey: 'stage-100',
    name: '直播大厅100方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventb_st200',
    pageKey: 'stage-200',
    name: '直播大厅200方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventb_st300',
    pageKey: 'stage-300',
    name: '直播大厅300方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventb_st500',
    pageKey: 'stage-500',
    name: '直播大厅500方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventb_se25',
    pageKey: 'session-25',
    name: '讨论室25方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventb_se50',
    pageKey: 'session-50',
    name: '讨论室50方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventb_se100',
    pageKey: 'session-100',
    name: '讨论室100方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventb_se300',
    pageKey: 'session-300',
    name: '讨论室300方',
  },
];

/** 高级版计费项 */
export const DELUXE_CHARGE_ITEMS = [
  {
    key: 'sv_tencentmeeting_saas_eventp_year',
    pageKey: 'year',
    name: '高级版版本功能',
  },
  {
    key: 'sv_tencentmeeting_saas_eventp_guest',
    pageKey: 'guestNum',
    name: '嘉宾数',
  },
  {
    key: 'sv_tencentmeeting_saas_eventp_host',
    pageKey: 'hostNum',
    name: '主持人数',
  },
  {
    key: 'sv_tencentmeeting_saas_eventp_admin',
    pageKey: 'adminNum',
    name: '主办方成员数',
  },
  {
    key: 'sv_tencentmeeting_saas_eventp_st100',
    pageKey: 'stage-100',
    name: '直播大厅100方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventp_st200',
    pageKey: 'stage-200',
    name: '直播大厅200方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventp_st300',
    pageKey: 'stage-300',
    name: '直播大厅300方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventp_st500',
    pageKey: 'stage-500',
    name: '直播大厅500方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventp_se25',
    pageKey: 'session-25',
    name: '讨论室25方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventp_se50',
    pageKey: 'session-50',
    name: '讨论室50方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventp_se100',
    pageKey: 'session-100',
    name: '讨论室100方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventp_se300',
    pageKey: 'session-300',
    name: '讨论室300方',
  },
];

/** 旗舰版计费项 */
export const ULTIMATE_CHARGE_ITEMS = [
  {
    key: 'sv_tencentmeeting_saas_eventu_year',
    pageKey: 'year',
    name: '旗舰版版本功能',
  },
  {
    key: 'sv_tencentmeeting_saas_eventu_guest',
    pageKey: 'guestNum',
    name: '嘉宾数',
  },
  {
    key: 'sv_tencentmeeting_saas_eventu_host',
    pageKey: 'hostNum',
    name: '主持人数',
  },
  {
    key: 'sv_tencentmeeting_saas_eventu_admin',
    pageKey: 'adminNum',
    name: '主办方成员数',
  },
  // {
  //   key: 'sv_tencentmeeting_saas_eventu_st100',
  //   pageKey: 'stage-100',
  //   name: '直播大厅100方',
  // },
  // {
  //   key: 'sv_tencentmeeting_saas_eventu_st200',
  //   pageKey: 'stage-200',
  //   name: '直播大厅200方',
  // },
  {
    key: 'sv_tencentmeeting_saas_eventu_st300',
    pageKey: 'stage-300',
    name: '直播大厅300方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventu_st500',
    pageKey: 'stage-500',
    name: '直播大厅500方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventu_st1000',
    pageKey: 'stage-1000',
    name: '直播大厅1000方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventu_st2000',
    pageKey: 'stage-2000',
    name: '直播大厅2000方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventu_st3000',
    pageKey: 'stage-3000',
    name: '直播大厅3000方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventu_st5000',
    pageKey: 'stage-5000',
    name: '直播大厅5000方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventu_st8000',
    pageKey: 'stage-8000',
    name: '直播大厅8000方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventu_st1w',
    pageKey: 'stage-10000',
    name: '直播大厅10000方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventu_se25',
    pageKey: 'session-25',
    name: '讨论室25方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventu_se50',
    pageKey: 'session-50',
    name: '讨论室50方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventu_se100',
    pageKey: 'session-100',
    name: '讨论室100方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventu_se300',
    pageKey: 'session-300',
    name: '讨论室300方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventu_se500',
    pageKey: 'session-500',
    name: '讨论室500方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventu_se1000',
    pageKey: 'session-1000',
    name: '讨论室1000方',
  },
  {
    key: 'sv_tencentmeeting_saas_eventu_se2000',
    pageKey: 'session-2000',
    name: '讨论室2000方',
  },
];

export const getChargeItem = (type: RuleType) => {
  if (type === RuleType.basic) return BASIC_CHARGE_ITEMS;
  if (type === RuleType.deluxe) return DELUXE_CHARGE_ITEMS;
  return ULTIMATE_CHARGE_ITEMS;
};

export interface ProductInfo {
  /** 新购id */
  goods_category_id: number;
  /** 变配id */
  change_goods_category_id: number;
  pid: number;
  productCode: string;
  subProductCode: string;
  name: string;
  upgradeName: string;
}

export type ProductMapData = Partial<Record<RuleType, ProductInfo>>;

/** 磐石信息map */
export const priceDataMap: ProductMapData = {
  [RuleType.basic]: {
    goods_category_id: 1026880,
    change_goods_category_id: 1026882,
    pid: 1023851,
    productCode: 'p_tencentmeeting_saas',
    subProductCode: 'sp_tencentmeeting_saas_eventb',
    name: '腾讯会议·活动（基础版）新购',
    upgradeName: '腾讯会议 活动 服务变更',
  },
  [RuleType.deluxe]: {
    goods_category_id: 1026883,
    change_goods_category_id: 1027424,
    pid: 1023886,
    productCode: 'p_tencentmeeting_saas',
    subProductCode: 'sp_tencentmeeting_saas_eventp',
    name: '腾讯会议·活动（高级版）新购',
    upgradeName: '腾讯会议 活动 服务变更',
  },
  [RuleType.ultimate]: {
    goods_category_id: 1026885,
    change_goods_category_id: 1027425,
    pid: 1023908,
    productCode: 'p_tencentmeeting_saas',
    subProductCode: 'sp_tencentmeeting_saas_eventu',
    name: '腾讯会议·活动（旗舰版）新购',
    upgradeName: '腾讯会议 活动 服务变更',
  },
};

/** 根据code找到产品的其他信息 */
export const getServiceData = (subProductCode: string) => {
  if (!subProductCode) return null;
  const findKey = Object.keys(priceDataMap).find((key) => {
    const mapKey = key as keyof ProductMapData;
    return priceDataMap[mapKey]?.subProductCode === subProductCode;
  });
  if (!findKey) return null;
  const findItemKey = findKey as keyof ProductMapData;
  const findItem = priceDataMap[findItemKey];
  return {
    ...findItem,
    key: findItemKey,
    name: findItem?.name.slice(0, -2),
  };
};
